onLoad(($) => {
  const nodesShareholderAccountPassive = $('.JS-shareholder-account-passive');

  if (!nodesShareholderAccountPassive.length) return;

  const PASSIVE_QUOTUM_DOCUMENT = 'input[name="ticket_passive_quotum[shareholder_document_number]"]';

  nodesShareholderAccountPassive.each((_index, element) => {
    const shareholderAccountsPath = element.dataset.shareholderAccountsPath;
    const shareholderDocumentSelector = element.dataset.shareholderDocument;

    const shareholderDocumentValue = () => {
      if (shareholderDocumentSelector) {
        const $field = $(shareholderDocumentSelector);
        if ($field.length) {
          const value = ($field.val() || '').trim();
          if (value) return value;
        }
      }

      return ($(PASSIVE_QUOTUM_DOCUMENT).val() || '').trim();
    };

    $(element).select2({
      ajax: {
        url: shareholderAccountsPath,
        dataType: 'json',
        data: function (params) {
          return {
            q: params.term,
            shareholder_document: shareholderDocumentValue()
          };
        }
      }
    });
  });
});
